/* eslint-disable react/require-default-props */
import React from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon = 'inbox', title, description }) => {
  return (
    <div className="text-center py-4 text-muted">
      <i className="material-icons mb-2" style={{ fontSize: 40 }}>
        {icon}
      </i>
      <p className="mb-0 font-weight-bold">{title}</p>
      {description && <small>{description}</small>}
    </div>
  );
};

export default EmptyState;
